export default {
  "hero.badge": "Niezależny zasób • Regularnie aktualizowany • Wielojęzyczny",
  "hero.title": "USFans Spreadsheet — znajdź produkty, porównuj i kupuj mądrzej",
  "hero.subtitle":
    "Odkryj USFans Spreadsheet, przeglądaj produkty według kategorii, porównuj dostępne informacje, poznaj wskazówki dotyczące kontroli jakości, wysyłki i zakupów, i podejmuj lepsze decyzje.",
  "hero.trust": "Nastawiony na bezpieczeństwo • Wskazówki QC • Poradniki wysyłki",

  "intro.title": "Czym jest USFans Spreadsheet?",
  "intro.p1":
    "USFans Spreadsheet to wspólny katalog produktów, który pomaga odkrywać, przeglądać i porównywać przedmioty z wielu kategorii — od butów i odzieży po torby i akcesoria.",
  "intro.p2":
    "Zamiast przeszukiwać niekończące się listy, możesz od razu przejść do kategorii poniżej, sprawdzić, co jest dostępne, i podążać za linkami, aby dowiedzieć się więcej na głównej stronie.",

  "categories.title": "Przeglądaj produkty USFans według kategorii",
  "categories.subtitle":
    "Wybierz kategorię, aby odkryć dostępne produkty. Każdy link otwiera odpowiadającą sekcję na głównej stronie USFans.",

  "how.title": "Jak działa Spreadsheet",
  "how.step1.title": "Wybierz kategorię",
  "how.step1.text": "Wybierz kategorię produktu z rozwijanego menu lub kart poniżej.",
  "how.step2.title": "Porównaj produkty",
  "how.step2.text": "Przejrzyj dostępne informacje o produkcie i porównaj to, co odpowiada Twoim potrzebom.",
  "how.step3.title": "Sprawdź QC i wysyłkę",
  "how.step3.text": "Przeczytaj nasze uwagi o kontroli jakości i wysyłce, aby wiedzieć, czego się spodziewać.",
  "how.step4.title": "Przejdź do głównej strony",
  "how.step4.text": "Podążaj za linkiem do głównej strony, aby zobaczyć szczegóły i dokończyć zamówienie.",

  "guide.title": "Przeczytaj nasz kompletny przewodnik",
  "guide.subtitle":
    "Nowy w USFans Spreadsheet? Nasz szczegółowy, oryginalny przewodnik wyjaśnia, jak to działa, co sprawdzić i jak kupować z pewnością.",
  "guide.read": "Czytaj przewodnik",

  "articles.title": "Najnowsze przewodniki i artykuły",
  "articles.subtitle":
    "Poznaj nasze oryginalne, szczegółowe przewodniki o USFans Spreadsheet — QC, wysyłka, kupony i bezpieczeństwo.",
  "articles.readMore": "Czytaj artykuł",

  "faq.title": "Często zadawane pytania",
  "faq.q1": "Czym jest USFans Spreadsheet?",
  "faq.a1":
    "To wspólny katalog produktów, który porządkuje przedmioty w kategorie, aby ułatwić przeglądanie i porównywanie.",
  "faq.q2": "Czy usfanslink.lol jest powiązane z USFans?",
  "faq.a2":
    "Nie. To niezależny zasób informacyjny i niekoniecznie jest powiązany z USFans.",
  "faq.q3": "Czy mogę kupować bezpośrednio na tej stronie?",
  "faq.a3":
    "Nie. Ta strona przekierowuje Cię do głównej strony USFans, gdzie możesz zobaczyć szczegóły i dokończyć zakup.",
  "faq.q4": "Jakie języki są obsługiwane?",
  "faq.a4":
    "Angielski, francuski, hiszpański i polski są dostępne w przełączniku języka w nagłówku.",

  "cta.title": "Gotowy, by odkryć Spreadsheet?",
  "cta.subtitle":
    "Wejdź do USFans Spreadsheet, przeglądaj produkty według kategorii i porównuj przed zakupem.",

  "safety.title": "Uwaga dotycząca bezpieczeństwa",
  "safety.text":
    "Zawsze weryfikuj szczegóły produktu, sprawdzaj zdjęcia QC, gdy są dostępne, i potwierdzaj warunki wysyłki przed zakupem. Ta strona udostępnia tylko informacje i nie sprzedaje produktów bezpośrednio.",
};